export const stateOptions = [
  { label: 'Cross Roads', value: 'Cross Roads' },
  { label: 'Aubrey', value: 'Aubrey' },
  { label: 'Little Elm', value: 'Little Elm' },
  { label: 'Denton', value: 'Denton' },
  { label: 'Frisco', value: 'Frisco' },
  { label: 'Prosper', value: 'Prosper' },
  { label: 'The Colony', value: 'The Colony' },
  { label: 'Celina', value: 'Celina' },
  { label: 'Pilot Point', value: 'Pilot Point' },
  { label: 'Dallas Texas', value: 'Dallas Texas' },
  { label: 'Fort Worth', value: 'Fort Worth' },
  { label: 'Arlington', value: 'Arlington' },
  { label: 'Irving', value: 'Irving' },
  { label: 'Garland', value: 'Garland' },
  { label: 'McKinney', value: 'McKinney' },
  { label: 'Carrollton', value: 'Carrollton' },
  { label: 'Lewisville', value: 'Lewisville' },
  { label: 'Flower Mound', value: 'Flower Mound' },
  { label: 'Allen', value: 'Allen' },
  { label: 'Richardson', value: 'Richardson' },
  { label: 'Fairview', value: 'Fairview' },
  { label: 'Plano', value: 'Plano' },
  { label: 'Highland Park', value: 'Highland Park' },
  { label: 'Other City', value: 'other' },
]
